import React, { useState, useEffect } from 'react';
import { Header } from './components/common/Header';
import { FluidMeshCanvas } from './components/common/FluidMeshCanvas';
import { CustomerStagePage } from './pages/CustomerStagePage';
import { PartnerPortalPage } from './pages/PartnerPortalPage';
import { AdminConsolePage } from './pages/AdminConsolePage';

export const App: React.FC = () => {
  const [currentPath, setCurrentPath] = useState<string>(() => {
    return window.location.pathname || '/';
  });
  const [isLiveCallActive, setIsLiveCallActive] = useState<boolean>(false);

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname || '/');
    };
    const handleCallState = (e: Event) => {
      const customEv = e as CustomEvent<{ isCallActive: boolean }>;
      setIsLiveCallActive(Boolean(customEv.detail?.isCallActive));
    };
    window.addEventListener('popstate', handlePopState);
    window.addEventListener('mehfil:call-state', handleCallState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('mehfil:call-state', handleCallState);
    };
  }, []);

  const handleNavigate = (path: string) => {
    window.history.pushState({}, '', path);
    setCurrentPath(path);
  };

  return (
    <div className="main-stage-container">
      {/* 60fps continuous multicolor fluid mesh canvas */}
      <FluidMeshCanvas />

      {/* Top Application Header */}
      <Header
        currentPath={currentPath}
        onNavigate={handleNavigate}
        isLiveActive={currentPath === '/' && isLiveCallActive}
      />

      {/* Route Switcher */}
      <main style={{ position: 'relative', zIndex: 10, flex: 1 }}>
        {currentPath === '/partner' ? (
          <PartnerPortalPage />
        ) : currentPath === '/admin' ? (
          <AdminConsolePage />
        ) : (
          <CustomerStagePage />
        )}
      </main>
    </div>
  );
};
